// Supabase client initialization - Debug version 2
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log("DEBUG: REACT_APP_SUPABASE_URL is ", supabaseUrl ? "Present" : "UNDEFINED");
console.log("DEBUG: REACT_APP_SUPABASE_ANON_KEY is ", supabaseAnonKey ? "Present" : "UNDEFINED");

// Create the client if variables exist, otherwise export null to prevent complete app crash
export const supabase = (supabaseUrl && supabaseAnonKey) 
  ? createClient(supabaseUrl, supabaseAnonKey) 
  : null;

